// 剧本生成任务详情路由组件
// 根据任务版本自动选择使用 v4 还是 v5 的详情页

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Spin, Alert } from 'antd'
import { getScriptGenerationTaskDetail } from '@/services/scriptGeneration'
import ScriptGenerationTaskDetail from './TaskDetail'
import ScriptGenerationTaskDetailV5 from './TaskDetailV5'

/**
 * 任务详情路由组件
 * 根据任务版本自动选择合适的详情页
 */
const TaskDetailRouter: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>()
  const [version, setVersion] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!taskId) {
      setError('无效的任务 ID')
      setLoading(false)
      return
    }

    const fetchTaskDetail = async () => {
      try {
        setLoading(true)
        const detail = await getScriptGenerationTaskDetail(taskId)
        setVersion(detail.version || '4.0')
      } catch (err) {
        setError('加载任务详情失败')
      } finally {
        setLoading(false)
      }
    }

    fetchTaskDetail()
  }, [taskId])

  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ padding: 48 }}>
        <Alert message={error} type="error" />
      </div>
    )
  }

  // 根据版本选择组件
  if (version === '5.0') {
    return <ScriptGenerationTaskDetailV5 />
  }

  // 默认使用 v4 组件
  return <ScriptGenerationTaskDetail />
}

export default TaskDetailRouter
